import { useSettings } from '@/hooks/queries';

const FALLBACK = ['Free shipping on orders over 100 €', 'Cut and sewn in Porto', 'Free returns within 30 days', 'A new piece joins the rail every Friday'];

/** The orange ticker. Messages are edited in WordPress under Settings → ODRA Headless. */
export function Marquee() {
  const { data } = useSettings();
  const msgs = data?.marquee.length ? data.marquee : FALLBACK;
  const row = msgs.flatMap((m) => [m, '◆']);
  const items = [...row, ...row, ...row, ...row];
  return (
    <div className="marquee" aria-hidden="true">
      <div className="track">{items.map((m, i) => <span key={i}>{m}</span>)}</div>
    </div>
  );
}
